import {cutHeadImg} from '@/common/util/global';
let mutations = {
    days21CardInitPrev(state, data) {
        data.story.story.sort((a, b) => {
            return a.pn - b.pn
        });
        data.question.sort((a, b) => {
            return a.pn -b.pn
        });
        state.question = data.question;
        state.question_pages = data.question.length;
        state.storys = data.story.story;
        state.storys_pages = data.story.story.length;
        state.total_pages = data.question.length + (data.story.story.length - 1) * 2;
        // state.demo_audio = data.training.demo_audio;
        state.period_id = Number(data.period_id);
        state.day_id = Number(data.day_id);       
        // state.total_days = (Number(data.training.period_id) - 1) * 21 + Number(data.training.day_id);
        // state.series_day = Number(data.training.series_day);
        // state.during = Number(data.training.during);
        state.cover_img = data.story.story[0].img;
        state.cover_title = data.story.story[0].title;
        state.cover_text = data.story.story[0].text;
        state.cover_audio = data.story.story[0].audio;
        // state.user_weixin_audio = data.training.user_weixin_audio;
        // state.loves = data.loves;
        //标记数据已经初始化
        state.inited = true;
    },
    days21CardUpdatePrev(state, data) {
        state.share_id = data;    
    }
}
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/habitCardPrev/mutations.js